import { useId, type MouseEvent } from 'react';
import { useLocation } from 'react-router-dom';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import { Box, Tooltip } from '@mui/material';
import { copyToClipboard } from 'framework/ui/clipboard';
import { TIMELINE_ENTRY_ID_PARAM } from '../constants';

export interface TimelineRecordAnchorProps {
  timelineId: string | number;
  basePathname?: string;
}

const TimelineRecordAnchor = ({ timelineId, basePathname = '' }: TimelineRecordAnchorProps) => {
  const instanceId = useId();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  searchParams.set(TIMELINE_ENTRY_ID_PARAM, String(timelineId));
  const link = `${basePathname || pathname}?${searchParams.toString()}`;

  const copyAnchor = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    copyToClipboard(event.currentTarget.href);
  };

  return (
    <Tooltip title="Copy link" placement="bottom-end" arrow>
      <Box
        component="a"
        id={`timeline-${instanceId}-anchor-${timelineId}`}
        className="timeline-anchor"
        aria-label="Copy link"
        href={link}
        onClick={copyAnchor}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
          ml: 0.5,
          color: 'text.secondary',

          '&:hover': { color: 'primary.main' },
        }}
      >
        <LinkOutlinedIcon sx={{ cursor: 'pointer', fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
};

export default TimelineRecordAnchor;
